<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="'Inquiry All Center'" :directory="$t('report')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                </div>
            </div>
            <div class="col-md-12">
                <app-overlay-loader v-if="preloader" />
                <div class="card">
                    <div class="table-wrapper">
                        <table class="table-Report" v-if="!preloader"  :class="{ 'loading-opacity': preloader }">
                            <tr>
                                <th rowspan="2" class="lf-0" style="white-space:nowrap;">CLC Centre</th>
                                <th 
                                    v-for="(item, index) in rowData.header.weekly"
                                    :key="index" style="max-width: 68px;"
                                >
                                    <div class="header-weekly" v-html="formatRange(item.min, item.max)"></div>
                                </th>
                                <th rowspan="2" style="max-width: 108px;">Sum Inquiry</th>
                                <th rowspan="2" style="max-width: 108px;">Clarify & Interview</th>
                                <th rowspan="2" style="max-width: 108px;">Become Student</th>
                            </tr>
                            <tr>
                                <th
                                    v-for="(item, index) in rowData.header.weekly"
                                    :key="'week-'+index"
                                >
                                    {{ item.week }}
                                </th>
                            </tr>
                            <tr
                                v-for="(bodyItem, bodyIndex) in rowData.body"
                                :key="bodyIndex"
                            >
                                <td style="white-space:nowrap;" class="lf-0" >
                                    {{ bodyItem.centre_name }}
                                </td>

                                <td
                                    v-for="(weekItem, weekIndex) in bodyItem.weekkly"
                                    :key="'week-'+weekIndex"
                                >
                                    {{ weekItem.total_weekly }}
                                </td>

                                <td>
                                    {{ bodyItem.total_inquiry }}
                                </td>

                                <td>
                                    {{ bodyItem.clarify_and_interview }}
                                </td>

                                <td>
                                    {{ bodyItem.become_student }}
                                </td>
                            </tr>
                            <tr>
                                <td class="lf-0" >
                                    Total Inquiry
                                </td>
                                <td
                                    v-for="(item, index) in rowData.header.weekly"
                                    :key="'value-'+index"
                                >
                                    {{ item.total_weekly }}
                                </td>
                                <td>
                                    {{ rowData.header.total_inquiry }}
                                </td>
                                <td>
                                    {{ rowData.header.clarify_and_interview }}
                                </td>
                                <td>
                                    {{ rowData.header.become_student }}
                                </td>
                            </tr>
                        </table>
                    </div>
                    
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {urlGenerator} from "../../../../Helpers/AxiosHelper";

export default {
    extends: CoreLibrary,
    name: "InquiryAllCenter",
    mixins: [],
	data() {
		return {
            semesterId: null,
            rowData: {
                header: {
                    total_inquiry : '',
                    clarify_and_interview : '',
                    become_student : '',
                    weekly : []
                },
                body: []
            },
			preloader: true,
        }
    },
    mounted() {
        this.loadData();
        
        window.addEventListener('academicCalendarChanged', (e) => {
            this.semesterId = e.detail.id;
            this.loadData(this.semesterId);
        });
    },
    methods: {
        async loadData(semesterId = null) {
            try {
			    this.preloader= true;
                const res = await axios.get(
                    `/report/get-data-inquiry-all-center`,
                    {
                        params: {
                            semester: semesterId
                        }
                    }
                );

                this.rowData = Array.isArray(res.data) ? res.data : res.data || [];
                this.preloader= false;
            } catch (err) {
                this.rowData = {
                    header: [],
                    body: []
                };
                this.preloader= false;
            }
        },
        formatDate(date) {
            const d = new Date(date);

            const day = String(d.getDate()).padStart(2, '0');

            const month = d.toLocaleDateString('en-GB', {
                month: 'short'
            });

            return `${day}-${month}`;
        },

        // FORMAT RANGE
        formatRange(min, max) {
            return `${this.formatDate(min)}-<br>${this.formatDate(max)}`;
        }
      
    },
}
</script>
<style scoped>
    .table-Report{
        border: 1px solid black;
    }
    .table-Report th{
        background: #007bff;
        color: white;
        padding: 10px;
        text-align: center;
        font-size: 12px;
        border: 1px solid black;
    }
    .table-Report td{
        background: white;
        font-size: 12px;
        color: black;
        padding: 10px;
        text-align: center;
        border: 1px solid black;
    }
    .header-weekly{
        white-space: nowrap;
        
    }
    .table-wrapper {
        border: 1px solid black;
        width: 100%;
        overflow-x: auto;
    }
    .table-Report {
        width: max-content; 
        min-width: 100%;  
        border-collapse: collapse;
    }
    .lf-0{
        position: sticky;
        left: 0;
    }
</style>
